export default __webpack_public_path__ + "arrow-solid.ef9afbd0779984fd.svg";